import React, { PureComponent } from 'react';
import { NavBar } from 'antd-mobile';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import './index.less';
import PropTypes from 'prop-types';
import leftcontent from '../../assets/toleft22.png';
import { isCsairApp } from '@csair/emp-helpers';

export class Header extends PureComponent {
  static defaultProps = {
    iconName: '',
    leftContent: <img src={leftcontent} />,
    rightContent: '',
    onLeftClick: () => {},
    style: {
      backgroundColor: 'transparent',
      color: '#262626',
    },
    title: 'navbar',
    navBar: {
      display: true,
    },
  };
  componentWillUnmount() {}
  render() {
    const {
      iconName,
      leftContent,
      onLeftClick,
      title,
      rightContent,
      style,
      navBar: { display },
    } = this.props;
    let isAICommingFT = window.sessionStorage.getItem('isAICommingFT');
    // isTTWebView 若为 true，则是在头条小程序的 web-view 中打开
    const isTTWebView = navigator.userAgent
      .toLowerCase()
      .includes('toutiaomicroapp');
    if (isCsairApp()) {
      window.CSNativeObject.nativeSetTitle &&
        window.CSNativeObject.nativeSetTitle(title);
    }
    return (
      !isTTWebView &&
      !isAICommingFT &&
      display && (
        <NavBar
          {...(iconName ? { iconName } : {})}
          leftContent={leftContent}
          onLeftClick={onLeftClick}
          rightContent={rightContent}
          style={style}
        >
          {title}
        </NavBar>
      )
    );
  }
}

Header.PropTypes = {
  iconName: PropTypes.string,
  onLeftClick: PropTypes.func,
  rightContent: PropTypes.array,
  style: PropTypes.object,
  title: PropTypes.string,
};

export default connect(
  state => ({
    navBar: state.App.navBar,
  }),
  dispatch => ({})
)(withRouter(Header));



// WEBPACK FOOTER //
// ./src/components/Header/index.js